import React, { useEffect, useState } from "react"

const ScrollProgressBar = ({ selectorToTrack }) => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      const element = document.querySelector(`${selectorToTrack}`)
      if (!element) return

      const elementRect = element.getBoundingClientRect()
      const elementTop = elementRect.top
      const elementHeight = elementRect.height
      const windowHeight = window.innerHeight
      const totalScroll = elementHeight - windowHeight

      if (elementTop < 0 && Math.abs(elementTop) <= totalScroll) {
        const progress = (Math.abs(elementTop) / totalScroll) * 100
        setProgress(progress)
      } else if (elementTop < 0 && Math.abs(elementTop) > totalScroll) {
        setProgress(100)
      } else {
        setProgress(0)
      }
    }

    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [selectorToTrack])

  return (
    <div
      className="scroll-progress-bar"
      style={{ width: `${progress}%` }}
    ></div>
  )
}

export default ScrollProgressBar
